import { mergeDeepRight } from "ramda";
import { default_settings } from "./default_settings.js";
import { local_settings } from "./local_settings.js";

const settings = mergeDeepRight(default_settings, local_settings);

export default settings;
